import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';
import type { ContactUrgency } from '@/services/api/generated/treatmentContactQueueService';

const urgencyBadgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      urgency: {
        'Escalate to Attorney': 'bg-red-100 text-red-800',
        Urgent: 'bg-orange-100 text-orange-800',
        Overdue: 'bg-yellow-100 text-yellow-800',
        Routine: 'bg-zinc-100 text-zinc-600',
      },
    },
    defaultVariants: {
      urgency: 'Routine',
    },
  },
);

const urgencyDotColors: Record<ContactUrgency, string> = {
  'Escalate to Attorney': 'bg-red-500',
  Urgent: 'bg-orange-500',
  Overdue: 'bg-yellow-500',
  Routine: 'bg-zinc-400',
};

interface UrgencyBadgeProps extends VariantProps<typeof urgencyBadgeVariants> {
  urgency: ContactUrgency;
  className?: string;
  showDot?: boolean;
}

export const UrgencyBadge = ({
  urgency,
  className,
  showDot = true,
}: UrgencyBadgeProps) => {
  return (
    <span className={cn(urgencyBadgeVariants({ urgency }), className)}>
      {showDot && (
        <span
          className={cn('h-1.5 w-1.5 rounded-full', urgencyDotColors[urgency])}
        />
      )}
      {urgency}
    </span>
  );
};
